import React from "react";
import { FeeRunContainer } from "../../../containers";

const FeeRunDetails = (props) => {
  return <FeeRunContainer {...props} />;
};

export default FeeRunDetails;
